import React, { forwardRef, useContext } from 'react';
import { StyledCheckbox } from './styles.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';
import { CheckboxGroupContext } from '../CheckboxGroup/CheckboxGroupContext.js';
import { useSafeLayoutEffect } from '../../hooks/useSafeLayoutEffect.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Accessible, ecosystem-agnostic native checkbox primitive. Use checkboxes in forms when a user needs to select
 * multiple values from several options.
 */
const Checkbox = /*#__PURE__*/forwardRef(({
  indeterminate,
  checked,
  disabled: disabledProp,
  required,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  onChange,
  name,
  sx: sxProp,
  value,
  ...props
}, forwardedRef) => {
  const innerRef = React.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const checkboxGroupContext = useContext(CheckboxGroupContext);
  const disabled = disabledProp || checkboxGroupContext.disabled;
  const handleOnChange = e => {
    checkboxGroupContext.onChange && checkboxGroupContext.onChange(e);
    onChange && onChange(e);
  };
  useSafeLayoutEffect(() => {
    if (innerRef.current) {
      innerRef.current.indeterminate = indeterminate || false;
    }
  }, [indeterminate, checked, innerRef]);
  return /*#__PURE__*/React.createElement(StyledCheckbox, _extends({
    type: "checkbox",
    checked: indeterminate ? false : checked,
    "aria-checked": indeterminate ? 'mixed' : checked ? 'true' : 'false',
    sx: sxProp,
    onChange: handleOnChange,
    ref: innerRef,
    disabled: disabled,
    "aria-disabled": disabled ? 'true' : 'false',
    required: required,
    "aria-required": required ? 'true' : 'false',
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    value: value,
    name: name
  }, props));
});
Checkbox.displayName = 'Checkbox';
var Checkbox$1 = Checkbox;

export { Checkbox$1 as default };
